import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import { Button as CanaveralButton } from '@storable/canaveral-components';
import PromoCode from './PromoCode';
import { Price } from '../../../../../../../src/web/components';
import AppliedPromos from './AppliedPromos';
import styles from '../Actions.scss';

const AmountDueAtMoveIn = ({
  facilityId,
  selectedPlan,
  price,
  discountedPrice,
  discountPlans,
  onPromoUpdate,
  primaryColorClass,
  primaryColorBackgroundClass,
  secondaryColorHoverClass,
  secondaryColorBackgroundClass,
  primaryColorBackgroundHoverClass,
  hidePricingDisplayCall,
  enablePublicDescription,
  softwareProvider,
  appliedPromos,
  buttonStyleClass,
}) => {
  // Define renderPrice function within AmountDueAtMoveIn
  const renderPrice = (priceValue, className) => {
    if (hidePricingDisplayCall) {
      return <div>CALL</div>;
    }
    return (
      <Price
        element="div"
        className={`${className} ${styles.price}`}
        value={priceValue}
        decimals={2}
      />
    );
  };

  // Define renderRates function within AmountDueAtMoveIn
  const renderRates = () => (
    <div>
      <Row>
        <Col xs={6}>{discountedPrice ? 'Web Rate' : 'Standard Rate'}</Col>
        <Col xs={6}>
          {discountedPrice
            ? renderPrice(price, styles.linethrough)
            : renderPrice(price, 'text-end')}
        </Col>
      </Row>
      {discountedPrice && (
        <Row>
          <Col xs={6} className={styles.discountedRate}>
            Discounted Rate
          </Col>
          <Col xs={6}>
            {renderPrice(discountedPrice, `text-end ${styles.discountedRate}`)}
          </Col>
        </Row>
      )}
      <Col xs={9} className={styles.appliedPromos}>
        <AppliedPromos
          discountPlans={appliedPromos}
          enablePublicDescription={enablePublicDescription}
        />
      </Col>
    </div>
  );

  return (
    <div>
      <div className={styles.subHeading}>
        Amount Due At Move-In
        <small className={styles.feeDescription}>
          *subject to fees at move-in
        </small>
      </div>
      <div className={styles.monthlyRate}>
        {renderRates()}
        <Row>
          {selectedPlan ? (
            <Col xs={12} className={styles.promoText}>
              <CanaveralButton
                onClick={() => onPromoUpdate(null)}
                icon="draft"
                label="Remove Promo"
                className={styles.selectedPlan}
              >
                {`${selectedPlan.name} - ${selectedPlan.description}`}
                <span
                  className={`${primaryColorBackgroundClass} ${styles.promoLabel}`}
                >
                  Promo
                </span>
              </CanaveralButton>
            </Col>
          ) : (
            <PromoCode
              facilityId={facilityId}
              discountPlans={discountPlans}
              onPromoUpdate={onPromoUpdate}
              softwareProvider={softwareProvider} // Pass softwareProvider prop to PromoCode
              primaryColorClass={primaryColorClass}
              primaryColorBackgroundClass={primaryColorBackgroundClass}
              secondaryColorHoverClass={secondaryColorHoverClass}
              secondaryColorBackgroundClass={secondaryColorBackgroundClass}
              primaryColorBackgroundHoverClass={primaryColorBackgroundHoverClass}
              appliedPromos={appliedPromos}
              buttonStyleClass={buttonStyleClass}
            />
          )}
        </Row>
      </div>
    </div>
  );
};

AmountDueAtMoveIn.propTypes = {
  facilityId: PropTypes.string,
  selectedPlan: PropTypes.object,
  price: PropTypes.number.isRequired,
  discountedPrice: PropTypes.number,
  discountPlans: PropTypes.array, // Removed `.isRequired`
  onPromoUpdate: PropTypes.func.isRequired,
  primaryColorClass: PropTypes.string,
  primaryColorBackgroundClass: PropTypes.string,
  secondaryColorHoverClass: PropTypes.string,
  secondaryColorBackgroundClass: PropTypes.string,
  primaryColorBackgroundHoverClass: PropTypes.string,
  hidePricingDisplayCall: PropTypes.bool,
  enablePublicDescription: PropTypes.bool,
  softwareProvider: PropTypes.string,
  appliedPromos: PropTypes.array,
  buttonStyleClass: PropTypes.string,
};

AmountDueAtMoveIn.defaultProps = {
  facilityId: undefined,
  selectedPlan: null,
  discountedPrice: null,
  discountPlans: [], // Kept default value since it's not required
  appliedPromos: [],
  primaryColorClass: '',
  primaryColorBackgroundClass: '',
  secondaryColorHoverClass: '',
  secondaryColorBackgroundClass: '',
  primaryColorBackgroundHoverClass: '',
  hidePricingDisplayCall: false,
  enablePublicDescription: false,
  softwareProvider: '',
  buttonStyleClass: undefined,
};

export default AmountDueAtMoveIn;
